import axios from 'axios'
import interceptorSetup from './httpInterceptor.js'

const callaxios = axios.create({
	baseURL: "http://34.199.176.17:13061",
	headers:{
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin' : "http://34.199.176.17:13061",
        'Access-Control-Allow-Methods' :  "POST, GET, OPTIONS, PUT, DELETE",
        'Access-Control-Allow-Headers' :  "Content-Type, X-Auth-Token, Origin, Authorization, UserId"
    },
    mode: 'no-cors'
    
});



interceptorSetup(callaxios)

export default callaxios